import i18next from "i18next";
import moment from "moment";
import { initReactI18next } from "react-i18next";
import defaultFile from "./default.json";
import fr from "./fr/dashfrenc.json";
import en from "./en/dashen.json";

const resources = {
    default: {
        translation: defaultFile["translation"],
    },
    en: {
        translation: en["translation"],
    },
    fr: {
        translation: fr["translation"],
    },
};
const i18nextInstance2 = i18next.createInstance();
i18nextInstance2
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        keySeparator: ".",
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources,
        lng: "ca", // if we use language detector, then we do not have to define the lng option
        fallbackLng: "default",

        interpolation: {
            escapeValue: false,
            // formatting functionalities, example: date or text formatting
            // We can have different formatting options here
            format: function (value, format, lng) {
                if (format === "uppercase") return value.toUpperCase();
                if (value instanceof Date) return moment(value).format(format);
                return value;
            },
        },
    });

export default i18nextInstance2;
